import { Routes, Route,useLocation, useNavigate } from "react-router-dom";
import {  AnimatePresence } from "framer-motion";
import axios from "axios";
import BASE_URL from "../../BaseUrl";
import NavBare from "./NavBare";
import AdminHome from "./AdminHome";
import AdminAssistants from "./AdminAssistants";
import AdminProfile from "./AdminProfile";
import FolderContent from "./FolderContent";
import { useEffect, useState, useContext } from "react";
import AdminAssistantPage from "./AdminAssistantPage";
import LessonPage from "./LessonPage";
import NewExamPage from "./NewExamPage";
import IntroLessonPage from "./IntroLessonPage";
import ExamReview from "./ExamReview";
import EditExam from "./EditExam";
import Footer from "../Footer";
import ExamResults from "./ExamResulsts";
import BatchQrPdfGenerator from "./BatchQrPdfGenerator";
import StudentsPage from "./StudentsPage";
import { GlobalContext } from "../GlobalContext";


import AdminPlansPage from "./../admin/AdminPlans";


export default function AdminPages(){
    const navigate = useNavigate();
    const location = useLocation();
    const {admin, setAdmin} = useContext(GlobalContext);
    const [loaded, setLoaded] = useState(false);
    const [active, setActive] = useState("");
    const [mobileActive, setMobileActive] = useState("");


    const fetchData =  async () => {
            let admin2 = admin;
            await axios.get(`${BASE_URL}/teacher/get-admin-by-token`, { withCredentials: true })
                .then((response) => {
                    admin2 = response.data;
                    
                }).catch((error) => {
                    navigate("/"); // Redirect to login if admin data is not available
                })
                if(admin2 === null || admin2 === undefined){
                    navigate("/");
                    return;
                }
            await axios.get(`${BASE_URL}/teacher/courses?adminId=${admin2.id}`, { withCredentials: true })
            .then((response) => {
                setAdmin({...admin2, courses: response.data});
                setLoaded(true);
            }).catch((error) => {
                console.error("Error fetching course data:", error);
                navigate("/");
                // Handle error appropriately, e.g., show a notification or redirect
            })
        
    }

    useEffect(()=>{
        fetchData();
    },[])


    return(
        <div>
            {loaded && (<div style={{
                background:"linear-gradient(195deg, #ffffff, #ffffff)",
                position:"absolute",
                 minHeight:"100vh", width:"100%"}}>
                    <NavBare admin={admin} active={active} setActive={setActive} mobileActive={mobileActive} setMobileActive={setMobileActive} />
                    <AnimatePresence mode="wait">
                    <Routes location={location} key={location.pathname}>
                        <Route path="/" element={<AdminHome active={active} setActive={setActive} mobilActive={mobileActive} setMobileActive={setMobileActive} />}/>
                        <Route path="admin-assistants" element={<AdminAssistants active={active} setActive={setActive} mobilActive={mobileActive} setMobileActive={setMobileActive} />}/>
                        <Route path="admin-profile" element={<AdminProfile active={active} setMobileActive={setMobileActive} setActive={setActive}/>}/>
                        <Route path="admin-students" element={<StudentsPage active={active} setActive={setActive} mobilActive={mobileActive} setMobileActive={setMobileActive}/>}/>
                        <Route path="folder/:parentId" element={<FolderContent active={active} setActive={setActive} mobilActive={mobileActive} setMobileActive={setMobileActive}/>} />
                        <Route path="admin-assistant-profile/:id" element={<AdminAssistantPage active={active} setActive={setActive}/>}/>
                        <Route path= "video-details/:id" element={<LessonPage setActive={setActive} setMobileActive={setMobileActive} />}/>
                        <Route path= "intro-lesson/:id" element={<IntroLessonPage setActive={setActive} setMobileActive={setMobileActive} />}/>
                        <Route path="/plans" element={<AdminPlansPage setActive={setActive} />}/>
                        <Route path="new-exam/:unitId" element={<NewExamPage setActive={setActive} setMobileActive={setMobileActive} isAdmin={true}/>}/>
                        <Route path="preview-exam/:examId" element={<ExamReview setActive={setActive} setMobileActive={setMobileActive} isAdmin={true}/>}/>
                        <Route path="edit-exam/:examId" element={<EditExam setActive={setActive} setMobileActive={setMobileActive} isAdmin={true} />}/>
                        <Route path="exam-results/:examId" element={<ExamResults setActive={setActive} setMobileActive={setMobileActive} isAdmin={true} />}/>
                        <Route path="lesson/qr-codes/:lessonId" element={<BatchQrPdfGenerator setActive={setActive} setMobileActive={setMobileActive} isAdmin={true} />} />
                    </Routes>
                    </AnimatePresence>      
               <Footer />
            </div>)}
        </div>
    )

}